import React from 'react';
import { cn } from '@/lib/utils';

interface FeedbackTabsProps {
  activeTab: 'overview' | 'service' | 'brand';
  onTabChange: (tab: 'overview' | 'service' | 'brand') => void;
  children: React.ReactNode;
}

export const FeedbackTabs: React.FC<FeedbackTabsProps> = ({
  activeTab,
  onTabChange,
  children
}) => {
  const tabs = [
    { id: 'overview', label: 'Overview', description: 'Summary and next steps' },
    { id: 'service', label: 'Service Delivery', description: 'Voice, warmth, structure' },
    { id: 'brand', label: 'Brand Alignment', description: 'Knowledge and standards' }
  ] as const;

  return (
    <div className="w-full">
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={cn(
                'group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm transition-colors',
                activeTab === tab.id
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              )}
            >
              <div className="text-left">
                <div className="font-semibold">{tab.label}</div>
                <div className="text-xs text-gray-500 mt-0.5">{tab.description}</div>
              </div>
            </button>
          ))}
        </nav>
      </div>
      <div className="mt-6">{children}</div>
    </div>
  );
};